import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface BillingEmailFieldProps {
  value: string;
  /**
   * Address invoices fall back to when the field is left blank — the org's registration
   * address in the console, the address being typed in the sign-up form. Blank while the
   * user has not entered one yet, which the description handles.
   */
  fallbackEmail: string;
  error?: string | null;
  disabled?: boolean;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

/**
 * Organization billing email. Shared by sign-up, the org profile form and platform checkout
 * so all three surfaces describe the field identically.
 */
export const BillingEmailField = ({
  value,
  fallbackEmail,
  error,
  disabled,
  onChange,
  onBlur,
}: BillingEmailFieldProps) => (
  <div className="space-y-2">
    <Label htmlFor="billing-email">Billing email</Label>
    <Input
      id="billing-email"
      type="email"
      autoComplete="email"
      maxLength={255}
      placeholder={fallbackEmail}
      value={value}
      disabled={disabled}
      aria-invalid={error ? true : undefined}
      aria-describedby="billing-email-description"
      onChange={event => onChange(event.target.value)}
      onBlur={onBlur}
    />
    <p id="billing-email-description" className="text-muted-foreground text-xs">
      Invoices are sent to this address. Leave blank to use {fallbackEmail || "your account email"}.
    </p>
    {error && <p className="text-destructive text-sm">{error}</p>}
  </div>
);
